import React from "react";
import { AiOutlineClose } from "react-icons/ai";

const ModalCloseButton = ({ onClose, className = "" }) => (
  <button
    type="button"
    className={`btn btn-light border rounded-circle d-flex align-items-center justify-content-center p-0 ${className}`}
    onClick={onClose}
    aria-label="Close"
    style={{ width: 36, height: 36, flexShrink: 0 }}
  >
    <AiOutlineClose size={20} />
  </button>
);

export default ModalCloseButton;
